module.exports = " <div class=\"modal-header\"> <h3 class=\"modal-title\" style=\"float:left\">{{ vm.title }}</h3> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" ng-click=\"vm.cancel()\" data-translate=\"ABBRECHEN\"></button> <button class=\"btn btn-serf\" ng-click=\"vm.ok()\">OK</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/dialog/okCancelTemplate.html
// module id = CYbW
// module chunks = 0